import React, {Component} from 'react';
import ReactDOM from 'react-dom';

class Releases extends Component {
  state = {
    url: null,
    playing: false,
    played: 0,
    canPlay: true,
    playingSong: {
      "album": 1,
      "track": 1
    }
  }

  oggAacMp3 = (url) => {

    let MULTIPLE_SOURCES = [
      { src: url + '.aac', type: 'audio/aac' },
      { src: url + '.ogg', type: 'audio/ogg' },
      { src: url + '.mp3', type: 'audio/mpeg' }
    ]

    return MULTIPLE_SOURCES

  }


componentDidMount() {
//  this.load(this.oggAacMp3("./music/Silegrail/1"), 1, 1, false);
  ReactDOM.findDOMNode(this.refs.player).addEventListener('ended',this.onEnded,false);
  ReactDOM.findDOMNode(this.refs.player).addEventListener('timeupdate',this.seeking,false);
  ReactDOM.findDOMNode(this.refs.player).addEventListener('canplaythrough',this.canplaythrough,false);
  this.highlightSong(1,1);
}
seeking = () => {
   let played = ReactDOM.findDOMNode(this.refs.player).currentTime / ReactDOM.findDOMNode(this.refs.player).duration;

   if (!this.state.seeking) {
     this.setState({played: played})
   }

 }

canplaythrough = () => {
  console.log("can")
    if(this.state.playing) {
      ReactDOM.findDOMNode(this.refs.player).play();
    }
    this.setState({ canPlay: true })

 }

 highlightSong = (album, track) => {

    let songs = ReactDOM.findDOMNode(this.refs['album' + album]).childNodes;

    for(let i = 0; i < songs.length; i++) {
       songs[i].style.removeProperty("color");
    }

    songs[track - 1].style.color = "white";
  }

  load = (url,album,track,playing) => {

    //this.setState({ playing: false })
    this.setState({
      played: 0,
      playing: true,
      canPlay: false,
      playingSong: {
        "album": album,
        "track": track
      }
    });
    this.highlightSong(album,track);

    ReactDOM.findDOMNode(this.refs.playerMp3).src = url + ".mp3";
    ReactDOM.findDOMNode(this.refs.playerOgg).src = url + ".ogg";
    ReactDOM.findDOMNode(this.refs.playerAac).src = url + ".aac";
    ReactDOM.findDOMNode(this.refs.player).load();
    //ReactDOM.findDOMNode(this.refs.player).play();

    //this.playPause;
    //if(playing){
      //this.setState({ playing: true })
    //}
    //console.log(this.state);
  }
  playPause = () => {
    //ReactDOM.findDOMNode(this.refs.player).pause();
    if(ReactDOM.findDOMNode(this.refs.player).paused) {
      ReactDOM.findDOMNode(this.refs.player).play();
      this.setState({ playing: true })
    } else {
      ReactDOM.findDOMNode(this.refs.player).pause();
      this.setState({ playing: false})
    }
  }

  onSeekMouseDown = e => {
  this.setState({ seeking: true })
  }
  onSeekChange = e => {
    this.setState({ played: parseFloat(e.target.value) })
  }
  onSeekMouseUp = e => {
    this.setState({ seeking: false })
    //this.player.seekTo(parseFloat(e.target.value))
    ReactDOM.findDOMNode(this.refs.player).currentTime = e.target.value * ReactDOM.findDOMNode(this.refs.player).duration;
  }
  onEnded = () => {
    if((this.state.playingSong.track + 1) <= ReactDOM.findDOMNode(this.refs['album' + this.state.playingSong.album]).childNodes.length) {
      this.load("./music/Silegrail/" + (this.state.playingSong.track + 1), this.state.playingSong.album, this.state.playingSong.track + 1);
    }

}

ref = player => {
    this.player = player
  }
  render() {

    const { played } = this.state;
    const playButton = () =>
    {
      //if(this.state.ready) {
      if(this.state.canPlay) {
        if(this.state.playing) {
          return <i className="fas fa-pause"></i>;
        } else {
          return <i className="fas fa-play"></i>;
        }
      } else {
        return <i className="fas fa-spinner spin"></i>;

      }
    }
    return (

      <section>
      <div className="Wrapper">
        <div className="Content">


            <div className="album">
            <div className="albumImage"><img src="/img/releases/Silegrail.jpg" alt="" /></div>
            <div className="albumSongs">

            <h2><strong>Silegrail</strong> – Silegrail (2017)</h2>
            <div className="playerButtons">
                <div className="playPause">
                    <button onClick={this.playPause}>{playButton()}</button>

                </div>
                <div className="seek">
                    <input
                                      type='range' min={0} max={1} step='any'
                                      value={played}
                                      onMouseDown={this.onSeekMouseDown}
                                      onTouchStart={this.onSeekMouseDown}
                                      onChange={this.onSeekChange}
                                      onMouseUp={this.onSeekMouseUp}
                                      onTouchEnd={this.onSeekMouseUp}

                                    />
                </div>
                <div className="clear"></div>
            </div>

            <ul ref="album1">
              <li onClick={() => this.load("./music/Silegrail/1", 1, 1, true) }>Introducing Silegrail<span>0:59</span></li>
              <li onClick={() => this.load("./music/Silegrail/2", 1, 2, true)}>The Raven<span>6:44</span></li>
              <li onClick={() => this.load("./music/Silegrail/3", 1, 3, true)}>Smell of Suicide<span>3:06</span></li>
              <li onClick={() => this.load("./music/Silegrail/4", 1, 4, true)}>Goodbye Mrs. Jane<span>5:07</span></li>
              <li onClick={() => this.load("./music/Silegrail/5", 1, 5, true)}>Look into the Past<span>6:33</span></li>
              <li onClick={() => this.load("./music/Silegrail/6", 1, 6, true)}>Rivers of Fears<span>14:07</span></li>
              <li onClick={() => this.load("./music/Silegrail/7", 1, 7, true)}>Disturbed<span>5:23</span></li>
              <li onClick={() => this.load("./music/Silegrail/8", 1, 8, true)}>New Dimension<span>5:49</span></li>
              <li onClick={() => this.load("./music/Silegrail/9", 1, 9, true)}>Symphony of Progress<span>14:31</span></li>
            </ul>
            </div>
          </div>
          <audio ref="player">
            <source src="./music/Silegrail/1.mp3" type="audio/mpeg" ref="playerMp3" />
            <source src="./music/Silegrail/1.aac" type="audio/aac" ref="playerAac" />
            <source src="./music/Silegrail/1.ogg" type="audio/ogg" ref="playerOgg" />
            Your browser does not support the audio tag.
          </audio>
      </div>
      </div>
    </section>);
  }
}

export default Releases;



// WEBPACK FOOTER //
// ./src/pages/Releases.js